import { render, staticRenderFns } from "./SavingsChallenge.vue?vue&type=template&id=22d7d4c6&scoped=true&"
import script from "./SavingsChallenge.vue?vue&type=script&lang=js&"
export * from "./SavingsChallenge.vue?vue&type=script&lang=js&"
import style0 from "./SavingsChallenge.vue?vue&type=style&index=0&id=22d7d4c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d7d4c6",
  null
  
)

export default component.exports